module.exports = __webpack_public_path__ + "static/img/图层 513.ec736dbb.png";